import {Box} from '@mui/material';
import styled from 'styled-components';
import {tokens} from "../../../theme";

export const StyledContainer = styled(Box)`
    padding: 40px;
    max-width: 1200px;
    background: ${({theme}) => theme.palette.background.paper};
    border: 1px solid ${({theme}) => theme.palette.dividers.subtle};;
    margin: 0 auto;
    border-radius: ${tokens.radius.xl};
    width: 80%;
`;

export const Header = styled(Box)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 2rem;
    flex-wrap: wrap;
    gap: 12px;
`;